<template>
    <div class="relative">
        <div class="manage-title"><em class="txt">推广信息</em></div>
        <div class="detailCode"><qriously :value="'https://' + task_url" :size="160" /><p>微信扫一扫查看推广内容</p></div>
        <div class="infoBox margin-top-20">
            <div class="item flex">
                <p class="tit">推广标题</p>
                <p class="txt">{{task_title}}</p>
            </div>
            <div class="item flex">
                <p class="tit">推广套餐</p>
                <p class="txt">￥{{task_price}}元</p>
            </div>
            <div class="item flex">
                <p class="tit">奖励类型</p>
                <p class="txt" v-if="reward_type == 0">赏金</p>
                <p class="txt" v-if="reward_type == 1">优惠券</p>
                <p class="txt" v-if="reward_type == 2">体验卡</p>
                <p class="txt" v-if="reward_type == 3">实物</p>
                <p class="txt" v-if="reward_type == 4">抽奖次数</p>
            </div>
            <div class="item flex">
                <p class="tit">预期点击量</p>
                <p class="txt">{{task_clicks}}+</p>
            </div>
            <div class="item flex">
                <p class="tit">订单编号</p>
                <p class="txt">{{task_sn}}</p>
            </div>
            <div class="item flex">
                <p class="tit">创建时间</p>
                <p class="txt">{{create_time}}</p>
            </div>
            <div class="item flex">
                <p class="tit">开始时间</p>
                <p class="txt">{{receipt_time}}</p>
            </div>
            <div class="item flex">
                <p class="tit">结束时间</p>
                <p class="txt">{{task_time}}</p>
            </div>
        </div>
    </div>
</template>
<script>
// import {Bus} from 'bus.js'
export default {
    name: 'ExtensionInfo',
    props: {
        task_title: String,
        task_price: String,
        task_clicks: String,
        task_sn: String,
        create_time: String,
        receipt_time: String,
        task_time: String,
        task_url: String,
        reward_type:String,
    },
    created(){
        // console.log('开始时间：',this.receipt_time,'结束时间',this.task_time)
    },
    // mounted(){
    //     // console.log(Bus)
    //     console.log('开始时间：',this.receipt_time,'结束时间',this.task_time)
    // }
}
</script>
<style scoped>
    .detailCode{position: absolute;right:60px;text-align: center;}
</style>
